import AddressProofError from './AddressProof/AddressProofError';
class AddressProofFileIsEmpty extends AddressProofError {
    constructor(options) {
        super('Address proof file not has information', options);
    }
}
export default AddressProofFileIsEmpty;
